import { render, staticRenderFns } from "./ClienteAtivo.vue?vue&type=template&id=0e72a7b3"
import script from "./ClienteAtivo.vue?vue&type=script&lang=js"
export * from "./ClienteAtivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports